import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'lokos-radio',
    templateUrl: './radio.component.html',
    styleUrl: './radio.component.scss',
    standalone: false,
})
export class RadioComponent implements OnChanges {
    @Input({ required: false }) control: FormControl = new FormControl();
    @Input({ required: false }) disabled = false;
    @Input({ required: false }) label = '';
    @Input({ required: false }) labelPosition: 'before' | 'after' = 'after';
    @Input({ required: false }) required = false;
    @Input({ required: false }) selected = false;
    @Input({ required: false }) value = '';

    @Output() onChange = new EventEmitter<any>();

    constructor(private translate: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }

    getErrorMessage() {
        const label = this.label
            ? this.translate.instant(this.label)
            : this.translate.instant('thisField');

        if (this.control.hasError('required')) {
            return `${label} ${this.translate.instant('isRequired')}}`;
        }
        return '';
    }
}
